import axios from "./axiosInstance";

const bulkEnquiryAPI ={ 
 form: (data) => axios.post("bulk-enquiry", data),
    
}

export default bulkEnquiryAPI;